/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Entity_IdInputs */

const cs_audit_entity_id = /** @type {(inputs: Audit_Entity_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID entity (UUID)`)
};

const en_audit_entity_id = /** @type {(inputs: Audit_Entity_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity id (UUID)`)
};

/**
* | output |
* | --- |
* | "Entity id (UUID)" |
*
* @param {Audit_Entity_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_entity_id = /** @type {((inputs?: Audit_Entity_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Entity_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_entity_id(inputs)
	return cs_audit_entity_id(inputs)
});